import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

class Countdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      expired: false,
    };
  }

  componentDidMount() {
    const { deadline, checkCountdown } = this.props;
    const end = moment.unix(deadline);
    let now = moment();
    let dur = moment.duration(end.diff(now));
    // let hours = Math.floor(dur.asHours());
    // let minutes = Math.floor(dur.asMinutes()) - hours * 60;
    // let seconds = Math.floor(dur.asSeconds()) - hours * 60 * 60 - minutes * 60;
    // this.setState({ hours, minutes, seconds });

    let minutes = Math.floor(dur.asMinutes());
    let seconds = Math.floor(dur.asSeconds()) - minutes * 60;
    this.setState({ minutes, seconds });


    this.interval = setInterval(() => {
      now = moment();
      const expired = end.isBefore(now) || end.isSame(now);
      dur = moment.duration(end.diff(now));
      // hours = Math.floor(dur.asHours());
      // minutes = Math.floor(dur.asMinutes()) - hours * 60;
      // seconds = Math.floor(dur.asSeconds()) - hours * 60 * 60 - minutes * 60;

      minutes = Math.floor(dur.asMinutes());
      seconds = Math.floor(dur.asSeconds()) - minutes * 60;

      if (expired) {
        // this.setState({ hours, minutes, seconds, expired });
        this.setState({ minutes, seconds, expired });
        if (this.interval) {
          clearInterval(this.interval);
        }
        checkCountdown(true);
      } else {
        // this.setState({ hours, minutes, seconds });
        this.setState({ minutes, seconds });
      }
    }, 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  render() {
    const { hours, minutes, seconds, expired } = this.state;

    if (expired) {
      return (
        <div className="countdown">
          00:00
        </div>
      );
    }

    return (
      <div className="countdown">
        {minutes.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2, useGrouping: false },
        )}
        :
        {seconds.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2, useGrouping: false },
        )}
      </div>
    );
  }
}

export default withRouter(Countdown);
